import React, { useCallback } from 'react';
import { default as BaseElement } from '../Element';
import { useEditorContext } from 'js/ydoc/docs/capabilities-assessment/EditorContext';

function Element({ ...props }) {
  const { page, element } = props;

  const { copyAdditionalElement } = useEditorContext();

  const handleCopy = useCallback(() => {
    copyAdditionalElement(page.guid, element.guid);
  }, [page, element, copyAdditionalElement]);

  return <BaseElement {...props} onCopy={handleCopy} />;
}

export default Element;
